module.exports = __webpack_public_path__ + "img/Service_content_3.3eb26b80.png";